<app-Login *ngIf="showLogin && !pdfBackup"></app-Login>

<mat-grid-list cols="18" *ngIf="!showLogin && !acceptedCookie">
  <app-cookie></app-cookie>
</mat-grid-list>

<mat-grid-list cols="18" rowHeight="100%" gutterSize="0" *ngIf="showLogin && pdfBackup">
  <mat-grid-tile colspan="3" class="leftNavTileColor">
    <app-left-side-menu class="fullComponent"></app-left-side-menu>
  </mat-grid-tile>
  <mat-grid-tile colspan="15">
    <div class="fullComponent flex-display flex-direction-column">
      <app-main-content class="main-content overflow-auto background-white"></app-main-content>
    </div>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="18" rowHeight="100%" gutterSize="0" *ngIf="!showLogin">
  <mat-grid-tile colspan="3" class="leftNavTileColor">
    <app-left-side-menu class="fullComponent"></app-left-side-menu>
  </mat-grid-tile>
  <mat-grid-tile colspan="15">
    <div class="fullComponent flex-display flex-direction-column">
      <app-main-content class="main-content overflow-auto background-white" [ngClass]="{'archive_highlight':isArchive}"></app-main-content>
      <app-footer role="region" aria-label="footer" class="footer display-content"></app-footer>
    </div>
  </mat-grid-tile>
</mat-grid-list>
<app-right-overlay></app-right-overlay>
<app-notification></app-notification>


